import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'ez-logout',
  imports: [
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  lastSsoProvider: string | null = null;
  challengeUrl: string | null = null;
  postLogoutRedirectUri: string | null = null;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.postLogoutRedirectUri = getAttribute('post-logout-redirect-uri');
  }

  ngOnInit(): void {
    this.lastSsoProvider = localStorage.getItem('lastSsoProvider');
    const challengeUrl = localStorage.getItem('challengeUrl');

    // grab query string parameter from url
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirectURL');
    this.challengeUrl = `${challengeUrl}?returnUrl=${redirectUrl}`;
  }

  clearSsoLocalStorageVariables(): void {
    localStorage.removeItem('lastSsoProvider');
    localStorage.removeItem('challengeUrl');
  }
}
